import React from "react";
import { type TicketFile } from "../../../../api/files";
import AttachmentItem from "./AttachmentItem";
import UploadButton from "./UploadButton";

type Props = {
  ticketId: number;
  attachments: TicketFile[];
  loading?: boolean;
  onRefresh: () => void;
};

export default function TicketAttachments({ ticketId, attachments, loading, onRefresh }: Props) {
  return (
    <section className="bg-white shadow-sm rounded-lg border border-slate-200">
      <header className="px-4 py-3 border-b border-slate-200 flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-slate-900">Attachments</h2>
          <p className="text-sm text-slate-500">Files are stored in MinIO; download via the links below.</p>
        </div>
        <UploadButton ticketId={ticketId} onUploadComplete={onRefresh} />
      </header>

      {loading ? (
        <div className="p-4 text-sm text-slate-600">Loading attachments...</div>
      ) : (
        <div className="p-4">
          {attachments.length === 0 ? (
            <div className="text-sm text-slate-500">No attachments yet. Upload files to see them here.</div>
          ) : (
            <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
              {attachments.map((file) => (
                <AttachmentItem key={file.id} ticketId={ticketId} file={file} onDelete={onRefresh} />
              ))}
            </div>
          )}
        </div>
      )}
    </section>
  );
}
